export default __webpack_public_path__ + "static/media/bg-achievement-3.7002ccd0.jpg";